<template>
    <div class="position-relative">
        <!-- Sección del escáner de código de barras -->
        <div v-if="scannerActive" id="scanner-container">
            <video ref="video" autoplay playsinline></video>
        </div>

        <button v-else type="button" class="top-0 end-0 btn btn-warning btn-block m-0 w-100 bg-secondary"
            style="height: 40vh" @click="startScanner">
            Comenzar a escanear
        </button>

        <button v-if="scannerActive" type="button"
            class="position-absolute top-0 end-0 btn btn-warning btn-block m-0 w-60 bg-secondary" style="height: 55px"
            @click="stopScanner">
            Recargar escaner
        </button>
    </div>
</template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library';

export default {
    props: {
        onDetect: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            codeReader: null,
            scannerActive: false,
        };
    },
    mounted() {
        window.addEventListener('beforeunload', this.stopScanner);
    },
    beforeUnmount() {
        this.stopScanner();
    },
    methods: {
        startScanner() {
            this.scannerActive = true;
            this.$nextTick(() => {
                this.codeReader = new BrowserMultiFormatReader();

                this.codeReader.decodeFromVideoDevice(
                    null,
                    this.$refs.video,
                    (result, error) => {
                        if (result) {
                            this.handleDetection(result.text);
                        }
                        if (error) {
                            if (error.name !== 'NotFoundException') {
                                console.error(error);
                            }
                        }
                    }
                ).catch((err) => {
                    console.error('Error al iniciar el escáner: ', err);
                    alert('No se pudo acceder a la cámara. Asegúrate de que tienes los permisos necesarios.');
                });
            });
        },
        handleDetection(code) {
            if (this.onDetect) {
                this.onDetect(code);
            }
            this.stopScanner(); // Detener el escaneo tras encontrar un código
        },
        stopScanner() {
            if (this.codeReader) {
                this.codeReader.reset();
                this.codeReader = null;
                this.scannerActive = false;
            }
        },
    },
};
</script>

<style scoped>
#scanner-container {
    width: 100%;
    height: 40vh;
    /* Ajusta el alto al 100% de la ventana */
    position: relative;
    overflow: hidden;
    /* Para que no haya desbordamiento del video */
}

#scanner-container video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    /* Hace que el video cubra todo el contenedor sin distorsión */
    position: absolute;
    top: 0;
    left: 0;
}


button {
    padding: 10px 20px;
    margin: 10px;
    font-size: 16px;
    cursor: pointer;
}
</style>